import { IS_DEV } from "@/config/constants";
import SegmentManager from "@/game/SegmentManager";
import type TileRepository from "@/game/TileRepository";

let sm: SegmentManager | null = null;

export const createSegmentManager = (tr: TileRepository): SegmentManager => {
	if (sm) throw new Error("SegmentManager already initialized");

	sm = new SegmentManager(tr);

	// @ts-expect-error - missing type in window
	if (!window.sm && IS_DEV) window.sm = sm;

	return sm;
};

export default (): SegmentManager => {
	if (!sm) throw new Error("SegmentManager not initialized");
	return sm;
};

export const isSegmentManagerInitialized = (): boolean => sm !== null;
